<template>
  <div class="admin-setting-container">
    <div class="admin-setting-content">
      <div class="admin-setting-header">
        <h2>管理员设置</h2>
        <p>修改管理员账号和密码</p>
      </div>
      
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="管理员账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>
        
        <el-form-item label="管理员邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入管理员邮箱"></el-input>
        </el-form-item>
        
        <el-form-item label="管理员密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入管理员密码"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings" :loading="loading">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminSetting',
  data() {
    return {
      form: {
        username: 'admin',
        email: 'admin@example.com',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入管理员邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入管理员密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  mounted() {
    // 初始化表单数据
    this.initForm()
  },
  methods: {
    initForm() {
      // 这里可以从后端获取当前管理员信息
      // 暂时使用默认值
    },
    saveSettings() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          // 调用后端API修改管理员信息
          axios.put('/admin/update', this.form)
            .then(() => {
              this.$message.success('设置保存成功')
              this.loading = false
            })
            .catch(() => {
              this.$message.error('设置保存失败，请稍后重试')
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.admin-setting-container {
  padding: 20px 0;
}

.admin-setting-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.admin-setting-header {
  margin-bottom: 30px;
}

.admin-setting-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.admin-setting-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.el-form-item__label {
  color: #666;
  font-weight: 500;
}

.el-input {
  width: 100%;
  max-width: 400px;
}

.el-button--primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  border: none;
  color: #000;
  font-weight: 600;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #00cc99, #00b386);
  color: #000;
}
</style>